import { render, staticRenderFns } from "./configuration-templates-synoptic-templates-modal-structure-form.vue?vue&type=template&id=11d6f048&scoped=true&"
import script from "./configuration-templates-synoptic-templates-modal-structure-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-templates-synoptic-templates-modal-structure-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-templates-synoptic-templates-modal-structure-form.scss?vue&type=style&index=0&id=11d6f048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d6f048",
  null
  
)

export default component.exports